import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Vuelidate from 'vuelidate'
import Vue2Filters from 'vue2-filters'
import vueDebounce from 'vue-debounce'
import Shave from 'shave'
import VueMq from 'vue-mq'
import filters from './filters'
import * as DOMPurify from 'dompurify'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import apolloProvider from '@/graphql'
import { ObserveVisibility } from 'vue-observe-visibility'
import PortalVue from 'portal-vue'
import 'vue-resize/dist/vue-resize.css'
import '@mdi/font/css/materialdesignicons.min.css'
import * as dateFns from 'date-fns'

Vue.use(Buefy, { defaultIconPack: 'mdi' })
Vue.use(VueDOMPurifyHTML)
Vue.use(Vuelidate)
Vue.use(vueDebounce)
Vue.use(PortalVue)
Vue.use(Vue2Filters)
Vue.directive('observe-visibility', ObserveVisibility)

Vue.use(VueMq, {
  breakpoints: {
    mobile: 768,
    tablet: 1025,
    desktop: 1217,
    widescreen: 1409,
    fullhd: Infinity
  },
  defaultBreakpoint: 'sm'
})

Object.defineProperty(Vue.prototype, '$DOMPurify', { value: DOMPurify })
Object.defineProperty(Vue.prototype, '$shave', { value: Shave })
Object.defineProperty(Vue.prototype, '$dateFns', { value: dateFns })

// add filters, such as the dateTime filter
for (const name in filters) {
  Vue.filter(name, filters[name])
}

Vue.prototype.$eventHub = new Vue()
Vue.config.productionTip = false
// Stub $userHasPermission for components that reference it (always false on public site)
Vue.prototype.$userHasPermission = function () { return false }

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
